/* eslint-disable camelcase */
export const relayTimetableExport = {
    export_timetable: "Export timetable",
    stages: "Stages",
    stages_description: "Each stage is exported with every segment inside it.",
    all_stages: "All stages",
    stages_selected: "{{ count }} of {{ total }} selected",
    stream: "Stream",
    stream_segments: "Stream-level segments",
    stream_segments_description: "The transfers and breaks which sit between stages rather than inside one.",
    include: "Include",
    leave_out: "Leave out",
} as const;
